import { idsMatch } from "../utils/ids";

const initialState = {
  bogies: [],
};

const bogieReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_BOGIES":
      return { ...state, bogies: action.payload };
    case "ADD_BOGIE":
      return { ...state, bogies: [...state.bogies, action.payload] };
    case "EDIT_BOGIE":
      return {
        ...state,
        bogies: state.bogies.map((b) =>
          idsMatch(b.id, action.payload.id) ? action.payload : b
        ),
      };
    case "DELETE_BOGIE":
      return {
        ...state,
        bogies: state.bogies.filter((b) => !idsMatch(b.id, action.payload)),
      };
    case "TOGGLE_BOGIE_ACTIVE":
      return {
        ...state,
        bogies: state.bogies.map((b) =>
          idsMatch(b.id, action.payload.id) ? action.payload : b
        ),
      };
    default:
      return state;
  }
};

export default bogieReducer;
